<!-- <template>
  <div>
     <v-parallax
      dark
      id="home"
      style="background-color: white; height: 100vh;"
    >
      <div class="text hidden-sm-and-down">
        <v-layout align-center row wrap justify-center>
          <v-flex xs5 sm5 md5 xl5 lg5 style="justify-content: right; display: grid;">
            <img src="/static/img/onechat/banner-homepage.jpg" style="height: 70vh;">
          </v-flex>
          <v-flex xs7 sm7 md7 xl7 lg7 style="margin-top: 4vh;">
            <v-layout align-center column justify-center wrap>
              <v-flex xs12 sm12 md12 xl12 lg12 style="margin-top: 4vh;">
                <img src="/static/img/icons/logoonechat_full.png" style="height: 100px; justify-content: right;">
            </v-flex>
            <v-flex xs12 sm12 md12 xl12 lg12 style="margin-top: 4vh;color: black;">
                <h1>ร่วมเป็นส่วนหนึ่งกับพวกเรา One Chat</h1>
            </v-flex>
                <v-flex xs12 sm12 md12 xl12 lg12 style="margin-top: 4vh;">
                <v-btn   class="buttonblue" @click="toPage('/register')">สมัครสมาชิก</v-btn>
                <v-btn   class="buttonblue" @click="loadepage()">ดาวน์โหลด</v-btn>
              </v-flex>
          </v-layout>
          </v-flex>
        </v-layout>
      </div>

      <div class="textmo hidden-md-and-up">
        <v-layout align-center column wrap justify-center>
          <v-flex xs12 sm12 >
            <v-layout align-center column justify-center>
              <img src="/static/img/onechat/banner-homepage.jpg" style="height: 30vh; justify-content: right;">
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12 style="margin-top: 3vh;">
            <v-layout align-center column justify-center>
            <v-flex xs12 sm12 style="margin-top: 1vh; color: black;">
                <h3>ร่วมเป็นส่วนหนึ่งกับพวกเรา</h3>
            </v-flex>
          </v-layout>
          </v-flex>
          <v-flex xs12 sm12 style="margin-top: 1vh;" >
            <v-layout align-center row wrap justify-center>
              <v-btn   class="buttonblue" style="width: 40%;" @click="toPage('/register')">สมัครสมาชิก</v-btn>
              <v-btn  class="buttonblue" style="width: 40%;" @click="loadepage()">ดาวน์โหลด</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>

      <div class="footer hidden-sm-and-down">
        <v-layout align-center row justify-center>
          <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toPage('/about')">เกี่ยวกับเรา</a></b> |</p>
          <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toNewTab('https://chat-develop.one.th/docs')">API</a></b></p>
          <p style="padding-left: 20px; padding-right: 20px; color: black;"><b>&copy; {{ new Date().getFullYear() }} One Centric Company Limited</b></p>
          <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toPage('/policy')" >นโยบาย</a></b> |</p>
          <p class="CSChatThai" style="padding-left: 5px;"><b><a style="color: black;" @click="toPage('/contactus')" >ติดต่อเรา</a></b></p>
        </v-layout>
      </div>

      <div class="footer hidden-md-and-up">
        <v-layout align-center column justify-center v-if="snackbar === true" style="margin-bottom: 9vh;">
          <v-flex xs12 md12>
            <v-layout align-center row justify-center>
              <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black !important;"><b><a style="color: black;" @click="toPage('/about')">เกี่ยวกับเรา</a></b> |</p>
              <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black !important;"><b><a style="color: black;" @click="toNewTab('https://chat-develop.one.th/docs')">API</a> |</b></p>
              <p class="CSChatThai" style="padding-left: 0px;color: black !important;"><b><a style="color: black;" @click="toPage('/policy')" >นโยบาย</a> |</b></p>
              <p class="CSChatThai" style="padding-left: 5px;color: black !important;"><b><a style="color: black;" @click="toPage('/contactus')" >ติดต่อเรา</a></b></p>
          </v-layout>
          </v-flex>
          <v-flex xs12 md12>
            <p style="padding-left: 20px; padding-right: 20px;color: black !important;"><b>&copy; {{ new Date().getFullYear() }} One Centric Company Limited</b></p>
          </v-flex>
        </v-layout>

        <v-layout align-center column justify-center v-else style="margin-bottom: 0vh;">
          <v-flex xs12 md12>
            <v-layout align-center row justify-center>
              <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black !important;"><b><a style="color: black !important;" @click="toPage('/about')">เกี่ยวกับเรา</a></b> |</p>
              <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black !important;"><b><a style="color: black !important;" @click="toNewTab('https://chat-develop.one.th/docs')">API</a> |</b></p>
              <p class="CSChatThai" style="padding-left: 0px;color: black !important;"><b><a style="color: black !important;" @click="toPage('/policy')" >นโยบาย</a> |</b></p>
              <p class="CSChatThai" style="padding-left: 5px;color: black !important;"><b><a style="color: black !important;" @click="toPage('/contactus')" >ติดต่อเรา</a></b></p>
            </v-layout>
          </v-flex>
          <v-flex xs12 md12>
            <p style="padding-left: 20px;color: black; padding-right: 20px;"><b>&copy; {{ new Date().getFullYear() }} One Centric Company Limited</b></p>
          </v-flex>
        </v-layout>
        <v-flex xs12 md12 style="background: #414141; margin: 0; bottom: 0px;position: fixed; width: 100%; height: 12vh; padding: 5px !important;" v-if="snackbar" class="CSChatThai">
          <v-layout align-center justify-center row fill-height>
            <v-flex xs2 md2>
              <v-btn icon flat  @click="closedownload()"><v-icon style="font-size: 18px !important;">close</v-icon></v-btn>
            </v-flex>
            <v-flex xs5 md5>
              {{ textsnackbar }}
            </v-flex>
            <v-flex xs5 md5>
              <v-btn color="info" @click="downloadios()" v-if="deviceos === 'ios'" drak>ดาวน์โหลด</v-btn>
            <v-btn color="info" @click="downloadandroid()" v-else drak>ดาวน์โหลด</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </div>
    </v-parallax>
  </div>
</template> -->
<template>
    <div
      dark
      id="home"
      style="background-color: white; height: 100vh; padding-top:64px; overflow-y:auto; overflow-x:hidden;"
      :class="$vuetify.breakpoint.mdAndUp ? 'Background' : 'BackgroundMobile'"
      v-if="status_login !== ''"
    >
    <v-layout style="">
      <!-- homepage web -->
      <div class="text">
        <v-layout align-center row wrap justify-center style="height:90vh;" fill-height class="hidden-sm-and-down">
          <v-flex xs12 sm12 md5 xl5 lg5 style="display: grid;" >
              <v-img src="/static/img/homepage/onechat_app.png" alt="banner onechat" style="max-height: 90vh;" />
              <v-flex xs12 sm12 md12 xl12 lg12  style="display: flex;margin-top: 4vh;color: black;">
                <v-layout justify-center>
                  <img src="/static/img/download/rsz_googleplay.png" @click="downloadapp_and()" width="200" height="60" alt="download onechat" class="mr-4 download">
                  <img src="/static/img/download/rsz_appstore.png" @click="downloadapp_ios()" width="200" height="60" alt="download onechat" class="download">
                </v-layout>
              </v-flex>
          </v-flex>
          <v-flex xs12 sm12 md7 xl7 lg7 style="margin-top: 4vh;" >
            <v-layout align-center column justify-center wrap>
              <v-flex xs12 sm12 md12 xl12 lg12 style="margin-top: 2vh;">
                <v-img src="/static/img/icons/logoonechat_full.png" alt="icon onechat" style="max-height: 100px; justify-content: center; width: 256px;" />
              </v-flex>
              <div style="margin-top: 6vh;color: black; font-size:20px;" >
                  <v-flex xs12 sm12 xl12 lg12>
                    <span>" แอปพลิเคชันแชทของคนไทยเพื่อคนไทย</span>
                  </v-flex>
                  <v-flex xs12 sm12 xl12 lg12>
                    <span>เราจะทำให้ทุกการสนทนาของคุณปลอดภัย "</span>
                  </v-flex>
              </div>
              <v-flex xs12 sm12 md12 xl12 lg12 class="hidden-sm-and-down" style="display: flex;margin-top: 6vh;color: black;">
                <v-btn to="/register" round dark class="btnhover" color="#2562B0">ร่วมเป็นส่วนหนึ่งกับพวกเรา</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout align-center row wrap justify-center  class="hidden-sm-and-down">
          <v-flex xs12 sm12 md12 xl12 lg12 style="margin-top:6em">
            <v-layout justify-center>
              <img src="/static/img/icons/logoonechat_full.png" width="120" height="50" />
               <h1 style="color:#2562B0; padding-left:20px;">คือ อะไร?</h1>
            </v-layout>
          </v-flex>
          <v-layout row wrap justify-center style="margin-top:1.5em;" class="hidden-sm-and-down" v-if="$vuetify.breakpoint.width <= 1028 && $vuetify.breakpoint.height >=1366">
               <v-card color="#BFDBFF" width="700" style="border-radius:10px; ">
                  <p style="padding: 20px; 20px; 20px; 10px; margin-bottom:0px; font-size:20px;" >
                    &nbsp;&nbsp;&nbsp;&nbsp; One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้
                  </p>
               </v-card>
                <v-flex xs12 sm12 md12 xl12 style="margin-left:10em; margin-right:10em; margin-top:140px;">
                 <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/one_platform.png"  style="height: 50vh;" >
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap justify-center align-center fill-height>
                      <div>
                        <v-card color="#BFDBFF" tile max-width="400" height="150"  class="cardstyle">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincard">One Chat เชื่อมต่อกับบริการใน One platform อย่าง One E-mail และ One Box </span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/one2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                        <v-flex xs12 sm12 md12 lg12 style="margin-top:2em;" >
                          <v-layout row justify-center>
                            <div>
                              <v-flex xs12 sm12 md12 >
                              <v-card color="#BFDBFF" tile width="250" height="130" style="margin-top:1em; border-radius:10px;" >
                                <v-layout align-center justify-center fill-height>
                                  <span class="textincard">บริการพื้นที่จัดเก็บไฟล์ข้อมูลฟรี</span>
                                  <v-avatar tile size="58" class="iconcard">
                                    <img src="/static/img/homepage/icon/box2x.png" />
                                  </v-avatar>
                                </v-layout>
                              </v-card>
                              </v-flex>
                              <v-layout justify-center>
                                <v-btn round dark color="#2562B0" target="_blank"  href="https://box.one.th/">ดูข้อมูลเพิ่มเติม</v-btn>
                              </v-layout>
                            </div>

                            <!-- <v-flex xs6 sm6 md6> -->
                              <div>
                              <v-card color="#BFDBFF" tile width="250" height="130"  style="margin-top:1em; border-radius:10px; margin-left:20px;" >
                                <v-layout align-center justify-center fill-height>
                                  <span class="textincard">บริการฟรีอีเมล</span>
                                  <v-avatar tile size="58" class="iconcard">
                                    <img src="/static/img/homepage/icon/mail2x.png" />
                                  </v-avatar>
                                </v-layout>
                              </v-card>
                              <v-layout justify-center>
                                <v-btn round color="#2562B0" style="margin-left:20px;" target="_blank" href=" https://mail.one.th/">ดูข้อมูลเพิ่มเติม</v-btn>
                              </v-layout>
                              </div>
                          </v-layout>
                        </v-flex>
                      </div>
                    </v-layout>
                  </v-flex>
                 </v-layout>
               </v-flex>
              <v-flex xs12 sm12 md12 xl12 style="margin-left:20em; margin-right:20em; margin-top:10em;">
                 <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/message_image.gif"  style="height: 60vh; border-radius:30px;">
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12 style="margin-top:3em;">
                    <v-layout row wrap justify-center align-center fill-height>
                      <div style="display: flex; flex-direction: column; align-items: center;">
                        <v-card color="#BFDBFF" tile width="400" height="150"  class="cardstyle" style="margin-left: 0; margin-right:0px; ">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincard">One Chat สามารถส่งข้อความ, ไฟล์, เสียง, รูปภาพ, และยังมีฟังก์ชันอื่น ๆ อีกมากมาย</span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/chat2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                      </div>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
               <v-flex xs12 sm12 md12 xl12 style="margin-left:20em; margin-right:20em; margin-top:10em;">
                 <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/multios.png"  style="height: 40vh;">
                    </v-layout>
                  </v-flex>
                  <v-flex xs122 sm12 md12>
                    <v-layout row wrap justify-center align-center fill-height>
                      <div style="">
                        <v-card color="#BFDBFF" tile width="400" height="190"  class="cardstyle">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincard">One Chat สามารถใช้งานได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS)
                            </span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/chat2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                        <v-flex xs12 sm12 md12 lg12 style="margin-top:2em;">
                          <v-layout justify-center>
                            <img src="/static/img/download/rsz_googleplay.png" @click="downloadapp_and()" width="130" height="50" alt="download onechat" class="mr-4 download">
                            <img src="/static/img/download/rsz_appstore.png" @click="downloadapp_ios()" width="130" height="50" alt="download onechat" class="download">
                          </v-layout>
                        </v-flex>
                      </div>
                    </v-layout>
                  </v-flex>
                 </v-layout>
               </v-flex>
              <v-flex xs12 sm12 md12 xl12 style="margin-left:20em; margin-right:20em; margin-top:10em;">
                 <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/web_develop.png"  style="height: 40vh;">
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12 style="margin-top:3em;">
                    <v-layout row wrap justify-center align-center fill-height>
                      <div style="display: flex; flex-direction: column; align-items: center;">
                        <v-card color="#BFDBFF" tile width="370" height="180"  class="cardstyle" style="margin-left: 0; margin-right:0px;">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincard">One Chat มีบริการ One Chat Bot ที่ให้บริการตอบกลับข้อความอัตโนมัติ เช่น ข้อความ, รูปภาพ, ไฟล์เอกสาร และข้อความในรูปแบบอื่น ๆ</span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/bot2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                        <v-btn round dark color="#2562B0" style="margin-top:20px;" :href="onechatDev" target="_blank">ดูข้อมูลเพิ่มเติม</v-btn>
                      </div>

                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
          </v-layout>
          <!-- web -->
          <v-layout align-center justify-space-around row wrap fill-height style="margin-top:1.5em; border-radius:10px;"  class="hidden-sm-and-down" v-else>
               <v-card color="#BFDBFF" width="700" style="border-radius:10px; ">
                  <p style="padding: 20px; 20px; 20px; 10px; margin-bottom:0px; font-size:20px;" >
                    &nbsp;&nbsp;&nbsp;&nbsp; One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้
                  </p>
               </v-card>

               <v-flex xs12 sm12 md12 xl12 style="margin-left:10em; margin-right:10em; margin-top:140px;">
                 <v-layout row wrap>
                  <v-flex xs5 sm5 md5>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/one_platform.png"  style="height: 50vh;" >
                    </v-layout>
                  </v-flex>
                  <v-flex xs2 sm2 md2></v-flex>
                  <v-flex xs5 sm5 md5>
                    <v-layout row wrap justify-start align-center fill-height>
                      <div>
                        <v-card color="#BFDBFF" tile max-width="400" height="150"  class="cardstyle">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincard">One Chat เชื่อมต่อกับบริการใน One platform อย่าง One E-mail และ One Box </span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/one2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                        <v-flex xs12 sm12 md12 lg12 style="margin-top:2em;" >
                          <v-layout justify-center>
                            <div>
                              <v-flex xs12 sm12 md12 >
                              <v-card color="#BFDBFF" tile width="250" height="130" style="margin-top:1em; border-radius:10px;" >
                                <v-layout align-center justify-center fill-height>
                                  <span class="textincard">บริการพื้นที่จัดเก็บไฟล์ข้อมูลฟรี</span>
                                  <v-avatar tile size="58" class="iconcard">
                                    <img src="/static/img/homepage/icon/box2x.png" />
                                  </v-avatar>
                                </v-layout>
                              </v-card>
                              </v-flex>
                              <v-layout justify-center>
                                <v-btn round dark color="#2562B0" target="_blank"  href="https://box.one.th/">ดูข้อมูลเพิ่มเติม</v-btn>
                              </v-layout>
                            </div>

                            <!-- <v-flex xs6 sm6 md6> -->
                              <div>
                              <v-card color="#BFDBFF" tile width="250" height="130"  style="margin-top:1em; border-radius:10px; margin-left:20px;" >
                                <v-layout align-center justify-center fill-height>
                                  <span class="textincard">บริการฟรีอีเมล</span>
                                  <v-avatar tile size="58" class="iconcard">
                                    <img src="/static/img/homepage/icon/mail2x.png" />
                                  </v-avatar>
                                </v-layout>
                              </v-card>
                              <v-layout justify-center>
                                <v-btn round color="#2562B0" style="margin-left:20px;" target="_blank" href=" https://mail.one.th/">ดูข้อมูลเพิ่มเติม</v-btn>
                              </v-layout>
                              </div>
                          </v-layout>
                        </v-flex>
                      </div>
                    </v-layout>
                  </v-flex>
                 </v-layout>
               </v-flex>
              <v-flex xs12 sm12 md12 xl12 style="margin-left:20em; margin-right:20em; margin-top:10em;">
                 <v-layout row wrap>
                  <v-flex xs5 sm5 md5>
                    <v-layout row wrap justify-center align-center fill-height>
                      <div style="display: flex; flex-direction: column; align-items: center; margin-right:100px;">
                        <v-card color="#BFDBFF" tile width="400" height="150"  class="cardstyle" style="margin-left: 0;">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincard">One Chat สามารถส่งข้อความ, ไฟล์, เสียง, รูปภาพ, และยังมีฟังก์ชันอื่น ๆ อีกมากมาย</span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/chat2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                      </div>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2 sm2 md2></v-flex>
                  <v-flex xs5 sm5 md5>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/message_image.gif"  style="height: 60vh; border-radius:30px; margin-left:150px;">
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
               <v-flex xs12 sm12 md12 xl12 style="margin-left:20em; margin-right:20em; margin-top:10em;">
                 <v-layout row wrap>
                  <v-flex xs5 sm5 md5>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/multios.png"  style="height: 40vh; margin-right:10em;">
                    </v-layout>
                  </v-flex>
                  <v-flex xs2 sm2 md2></v-flex>
                  <v-flex xs5 sm5 md5>
                    <v-layout row wrap justify-start align-center fill-height>
                      <div style="margin-left:30px;">
                        <v-card color="#BFDBFF" tile width="400" height="190"  class="cardstyle">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincard">One Chat สามารถใช้งานได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS)
                            </span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/chat2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                        <v-flex xs12 sm12 md12 lg12 style="margin-top:2em;">
                          <v-layout justify-center>
                            <img src="/static/img/download/rsz_googleplay.png" @click="downloadapp_and()" width="130" height="50" alt="download onechat" class="mr-4 download">
                            <img src="/static/img/download/rsz_appstore.png" @click="downloadapp_ios()" width="130" height="50" alt="download onechat" class="download">
                          </v-layout>
                        </v-flex>
                      </div>
                    </v-layout>
                  </v-flex>
                 </v-layout>
               </v-flex>
              <v-flex xs12 sm12 md12 xl12 style="margin-left:20em; margin-right:20em; margin-top:10em;">
                 <v-layout row wrap>
                  <v-flex xs4 sm4 md4>
                    <v-layout row wrap justify-center align-center fill-height>
                      <div style="display: flex; flex-direction: column; align-items: center; margin-right:120px;">
                        <v-card color="#BFDBFF" tile width="370" height="180"  class="cardstyle" style="margin-left: 0; margin-right:0px;">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincard">One Chat มีบริการ One Chat Bot ที่ให้บริการตอบกลับข้อความอัตโนมัติ เช่น ข้อความ, รูปภาพ, ไฟล์เอกสาร และข้อความในรูปแบบอื่น ๆ</span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/bot2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                        <v-btn round dark color="#2562B0" style="margin-top:20px;" :href="onechatDev" target="_blank">ดูข้อมูลเพิ่มเติม</v-btn>
                      </div>

                    </v-layout>
                  </v-flex>
                  <v-flex xs3 sm3 md3></v-flex>
                  <v-flex xs5 sm5 md5>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/web_develop.png"  style="height: 40vh; margin-left:80px;">
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
          </v-layout>
        </v-layout>

      <!-- mobile -->
      <v-layout row wrap justify-center class="hidden-md-and-up">
        <v-flex xs12 sm12 style="padding-top:3em;">
          <v-layout justify-center>
          <img src="/static/img/icons/logoonechat_full.png" alt="icon onechat" style="max-height: 100px; justify-content: center; width: 256px;" />
          </v-layout>
        </v-flex>
        <div style="margin-top: 2em;color: black; font-size:15px;">
          <v-flex xs12 sm12 xl12 lg12>
            <span>" แอปพลิเคชันแชทของคนไทยเพื่อคนไทย</span>
          </v-flex>
          <v-flex xs12 sm12 xl12 lg12>
            <span>เราจะทำให้ทุกการสนทนาของคุณปลอดภัย "</span>
          </v-flex>
        </div>
        <v-flex xs12 sm12 md12 xl12 lg12 style="display: flex;margin-top: 6vh; margin-bottom:3em; color: black; justify-content: center;">
          <v-btn to="/register" round dark color="#2562B0">ร่วมเป็นส่วนหนึ่งกับพวกเรา</v-btn>
        </v-flex>
        <img src="/static/img/homepage/onechat_app.png" alt="banner onechat" class="hidden-md-and-up" style="max-height: 40vh;"  />
        <v-flex xs12 sm12 md12 xl12 lg12 style="display: flex;margin-top: 4vh;color: black;">
          <v-layout justify-center>
            <img src="/static/img/download/rsz_googleplay.png" @click="downloadapp_and()" height="60" style="max-width:150px;" alt="download onechat" class="mr-4 download">
            <img src="/static/img/download/rsz_appstore.png" @click="downloadapp_ios()" height="60" style="max-width:150px;"  alt="download onechat" class="download">
          </v-layout>
        </v-flex>






          <!-- mobile -->
          <v-layout row wrap >
            <v-flex xs12 sm12 md12 xl12 lg12 style="margin-top:6em" class="hidden-md-and-up">
              <v-layout justify-center>
                <img src="/static/img/icons/logoonechat_full.png" width="120" height="50" />
                  <h1 style="color:#2562B0; padding-left:20px;">คือ อะไร?</h1>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm12 md12 style="margin-top:2em">
              <v-layout justify-center>
                <v-card color="#BFDBFF" width="480" style="border-radius:10px; ">
                    <p style="padding: 20px; 20px; 20px; 10px; font-size:18px; margin-bottom:0px;" >
                      &nbsp;&nbsp;&nbsp;&nbsp; One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้
                    </p>
                </v-card>
              </v-layout>
            </v-flex>

               <v-flex xs12 sm12 md12 xl12 style="margin-top:5em;">
                 <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/one_platform.png"  style="width: 90vw; height: intrinsic; margin-bottom:20px;">
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md6 style="margin-top:3em;">
                    <v-layout row wrap justify-center align-center fill-height>
                      <div style="">
                        <v-card color="#BFDBFF" tile width="300" height="130"  class="cardstyle">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincardMobile">One Chat เชื่อมต่อกับบริการใน One platform อย่าง One E-mail และ One Box </span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/one2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                        <v-flex xs12 sm12 md12 lg12 style="margin-top:2em;" >
                          <v-layout justify-center>
                            <div>
                              <v-flex xs12 sm12>
                                <v-card color="#BFDBFF" tile width="150" height="150" style="margin-top:1em; border-radius:10px;" >
                                  <v-layout align-center justify-center fill-height>
                                    <span class="textincardMobile">บริการพื้นที่จัดเก็บไฟล์ข้อมูลฟรี</span>
                                    <v-avatar tile size="58" class="iconcard">
                                      <img src="/static/img/homepage/icon/box2x.png" />
                                    </v-avatar>
                                  </v-layout>
                                </v-card>
                              </v-flex>
                              <v-layout justify-center>
                                <v-btn round dark color="#2562B0" target="_blank" href="https://box.one.th/">ดูข้อมูลเพิ่มเติม</v-btn>
                              </v-layout>
                            </div>
                            <div>
                              <v-flex xs12 sm12>
                                <v-card color="#BFDBFF" tile width="150" height="150"  style="margin-top:1em; border-radius:10px; margin-left:30px;" >
                                  <v-layout align-center justify-center fill-height>
                                    <span class="textincardMobile">บริการฟรีอีเมล</span>
                                    <v-avatar tile size="58" class="iconcard">
                                      <img src="/static/img/homepage/icon/mail2x.png" />
                                    </v-avatar>
                                  </v-layout>
                                </v-card>
                              </v-flex>
                              <v-layout justify-center>
                                <v-btn round color="#2562B0" style="margin-left:40px;" target="_blank" href=" https://mail.one.th/">ดูข้อมูลเพิ่มเติม</v-btn>
                              </v-layout>
                            </div>
                          </v-layout>
                        </v-flex>
                      </div>
                    </v-layout>
                  </v-flex>
                 </v-layout>
               </v-flex>

                  <v-flex xs12 sm12 md12 style="margin-top:5em;">
                    <v-layout justify-center>
                      <img src="/static/img/homepage/message_image.gif"  style="height: 60vh; border-radius:30px;">
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12 style="margin-top:3em;">
                    <v-layout row wrap justify-center align-center fill-height>
                      <div style="display: flex; flex-direction: column; align-items: center; ">
                        <v-card color="#BFDBFF" tile width="300" height="170"  class="cardstyle">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincardMobile">One Chat สามารถส่งข้อความ, ไฟล์, เสียง, รูปภาพ, และยังมีฟังก์ชันอื่น ๆ อีกมากมาย</span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/chat2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                      </div>
                    </v-layout>
                  </v-flex>

              <v-flex xs12 sm12 md12 xl12 style="margin-top:5em;">
                 <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/multios.png"  style="width: 90vw; height: intrinsic; max-height: 100vh;">
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12 style="margin-top:3em;">
                    <v-layout row wrap justify-center align-center fill-height>
                      <div style="display: flex; flex-direction: column; align-items: center;">
                        <v-card color="#BFDBFF" tile width="300" height="170"  class="cardstyle">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincardMobile">One Chat สามารถใช้งานได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS)
                            </span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/chat2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                      </div>
                        <v-flex xs12 sm12 md12 lg12 style="margin-top:2em;">
                          <v-layout justify-center>
                            <img src="/static/img/download/rsz_googleplay.png" @click="downloadapp_and()" width="130" height="50" alt="download onechat" class="mr-4 download">
                            <img src="/static/img/download/rsz_appstore.png" @click="downloadapp_ios()" width="130" height="50" alt="download onechat download">
                          </v-layout>
                        </v-flex>
                    </v-layout>
                  </v-flex>
                 </v-layout>
              </v-flex>

              <v-flex xs12 sm12 md12 xl12 style="margin-top:5em;">
                 <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/web_develop.png"  style="width: 90vw; height: intrinsic;">
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12 style="margin-top:3em;">
                    <v-layout row wrap justify-center align-center fill-height>
                      <div style="display: flex; flex-direction: column; align-items: center; ">
                        <v-card color="#BFDBFF" tile width="300" height="180" class="cardstyle">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincardMobile">One Chat มีบริการ One Chat Bot ที่ให้บริการตอบกลับข้อความอัตโนมัติ เช่น ข้อความ, รูปภาพ, ไฟล์เอกสาร และข้อความในรูปแบบอื่น ๆ</span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/bot2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                        <v-btn round dark color="#2562B0" style="margin-top:20px;" :href="onechatDev" target="_blank">ดูข้อมูลเพิ่มเติม</v-btn>
                      </div>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
          </v-layout>
      </v-layout>
      </div>
      <messageusDialog :dialogus="dialogus" @closeDialogus="closeDialogus"/>
      <ProblemDialog :dialogProblem="dialogProblem" @closeDialogProblem="closeDialogProblem"></ProblemDialog>
    </v-layout>
      <!-- footer web-->
      <div class="footer hidden-sm-and-down" >
        <v-footer height="auto" style="">
          <v-card class="flex" style="background-color:transparent;" flat tile>
            <v-card-title class="footertitle"  >
              <v-layout row wrap>
                <v-flex xs4 sm4 md4>
                  <v-layout justify-end>
                    <img src="/static/img/homepage/onecentric_logo.png" style="width:260px;" alt="">
                  </v-layout>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <v-layout justify-center style="padding-left:20px;">
                    <div >
                      <v-flex xs12 sm12 md12 style="padding-bottom:30px; ">
                        <v-layout justify-start>
                          <b >บริษัท วัน เซ็นทริค จำกัด</b>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm12 md12  style="padding-bottom:30px;">
                        <v-layout justify-start>
                          <div>
                            <span style="display:flex-inline;"> เวลาทำการ วันจันทร์ - ศุกร์ </span>
                            <br />
                            <span style="display:flex;">เวลา 09.00 - 17.00 น.</span>
                          </div>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm12 md12 style="">
                        <v-layout row wrap>
                          <!-- <v-flex xs12 sm12 md12> -->
                            1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16
                           <!-- </v-flex> -->
                        </v-layout>
                        <v-layout row wrap>
                          <!-- <v-flex xs12 sm12 md12> -->
                            ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ
                          <!-- </v-flex> -->
                        </v-layout>
                        <v-layout row wrap>
                          <!-- <v-flex xs12 sm12 md12> -->
                            เขตห้วยขวาง กรุงเทพมหานคร 10310
                          <!-- </v-flex> -->
                        </v-layout>
                      </v-flex>
                    </div>
                  </v-layout>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <v-layout align-start row wrap justify-start fill-height>
                    <div>
                      <v-flex xs12 sm12 md12>
                        <v-layout column wrap justify-center>
                          <v-flex>
                            <v-layout row wrap>
                              <v-flex xs2 sm2 style="padding-right:30px; padding-bottom:15px; ">
                                <v-icon>email</v-icon>
                                </v-flex>
                                <v-flex >
                                <v-layout row wrap align-center>
                                  <span href="mailto:onechat@one.th" style="cursor:pointer;" class="footerlink" >onechat@one.th</span>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                              <v-flex xs2 sm2 style="padding-right:30px; padding-bottom:15px;">
                                <v-icon>mdi-book-variant</v-icon>
                              </v-flex>
                              <v-flex>
                                <v-layout row wrap align-center>
                                  <span @click="toPage('/policy')" style="cursor:pointer;" class="footerlink">นโยบายการใช้งาน</span>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                              <v-flex xs2 sm2 style="padding-right:30px; padding-bottom:15px;">
                                <v-icon>chat</v-icon>
                              </v-flex>
                              <v-flex>
                                <v-layout row wrap align-center>
                                  <span  style="cursor:pointer;" @click.stop="dialogus = !dialogus" class="footerlink">ส่งข้อความถึงเรา</span>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>

            </v-card-title>
          </v-card>
        </v-footer>

        <div class="problemIcon hidden-sm-and-down" >
          <v-tooltip left>
           <v-btn fab dark slot="activator" @click.stop="dialogProblem = !dialogProblem" style="background: #2662af;    height: 60px !important;width: 60px !important;">
             <v-icon style="font-size: 30px;">fas fa-bullhorn</v-icon>
           </v-btn>
          <span>พบเจอปัญหา</span>
        </v-tooltip>
        </div>
      </div>
      <!-- footer mobile-->
      <div class="footerMobile hidden-md-and-up">
        <!-- ipad -->
        <v-footer height="auto" style="" v-if="$vuetify.breakpoint.width >= 768">
          <v-card class="flex" style="background-color:transparent;" flat tile>
            <v-card-title class="footermobiletext">
              <v-layout row wrap>
                <v-flex xs4 sm4 md4>
                  <v-layout justify-center>
                    <img src="/static/img/homepage/onecentric_logo.png" style="width:220px; height: intrinsic;" alt="">
                  </v-layout>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <v-layout justify-center style="padding-left:20px;">
                    <div>
                      <v-flex xs12 sm12 md12 style="padding-bottom:30px; ">
                        <b>บริษัท วัน เซ็นทริค จำกัด</b>
                      </v-flex>
                      <v-flex xs12 sm12 md12  style="padding-bottom:30px;">
                        <span style=""> เวลาทำการ วันจันทร์ - ศุกร์ </span>
                        <br>
                        <span>เวลา 09.00 - 17.00</span>
                      </v-flex>
                      <v-flex xs12 sm12 md12 style="padding-bottom:30px;">
                            <span>
                              1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16
                              <br>
                              ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ
                              <br>
                              เขตห้วยขวาง กรุงเทพมหานคร 10310
                            </span>
                      </v-flex>
                    </div>
                  </v-layout>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <v-layout align-start row wrap justify-center fill-height>
                    <div>
                      <v-flex xs12 sm12 md12>
                        <v-layout column wrap justify-center>
                          <v-flex>
                            <v-layout row wrap>
                              <v-flex xs2 sm2 style="padding-right:30px; padding-bottom:15px; ">
                                <v-icon>email</v-icon>
                                </v-flex>
                                <v-flex >
                                <v-layout row wrap align-center>
                                  <a href="mailto:onechat@one.th" style="color:black !important;" class="footerlink">onechat@one.th</a>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                              <v-flex xs2 sm2 style="padding-right:30px; padding-bottom:15px;">
                                <v-icon>mdi-book-variant</v-icon>
                              </v-flex>
                              <v-flex>
                                <v-layout row wrap align-center>
                                  <span @click="toPage('/policy')" style="cursor:pointer;" class="footerlink">นโยบายการใช้งาน</span>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                              <v-flex xs2 sm2 style="padding-right:30px; padding-bottom:15px;">
                                <v-icon>chat</v-icon>
                              </v-flex>
                              <v-flex>
                                <v-layout row wrap align-center>
                                  <span  style="cursor:pointer;" @click.stop="dialogus = !dialogus" class="footerlink">ส่งข้อความถึงเรา</span>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>

            </v-card-title>
          </v-card>
        </v-footer>
        <v-footer height="auto" v-else>
          <v-card class="flex" style="background-color:transparent;" flat tile>
            <v-card-title class="">
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-layout justify-center>
                    <img src="/static/img/homepage/onecentric_logo.png" style="width:300px; height: intrinsic;" alt="">
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-layout justify-center>
                    <div style="padding-left:25px;">
                    <v-flex xs12 sm12 md12 style="margin-bottom:15px;">
                      <b>บริษัท วัน เซ็นทริค จำกัด</b>

                    </v-flex>
                    <v-flex xs12 sm12 md12 style="margin-bottom:15px;">
                      <span style=""> เวลาทำการ วันจันทร์ - ศุกร์ </span>
                      <br>
                      <span>เวลา 09.00 - 17.00</span>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                        <!-- <v-layout align-center fill-height> -->
                          <span >
                            1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16
                            <br>
                            ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ
                            <br>
                            เขตห้วยขวาง กรุงเทพมหานคร 10310
                          </span>
                        <!-- </v-layout> -->
                    </v-flex>
                      <v-flex xs12 sm12 md12 style="margin-top:15px;">
                        <v-layout column wrap justify-center>
                          <v-flex>
                            <v-layout row wrap>
                              <v-flex xs2 sm2>
                                <v-icon>email</v-icon>
                              </v-flex>
                              <v-flex >
                                <v-layout row wrap align-center>
                                  <span href="mailto:onechat@one.th" style="color:black !important;" class="footerlink">onechat@one.th</span>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                              <v-flex xs2 sm2>
                                <v-icon>mdi-book-variant</v-icon>
                              </v-flex>
                              <v-flex>
                                <v-layout row wrap align-center>
                                  <span @click="toPage('/policy')" style="cursor:pointer;" class="footerlink">นโยบายการใช้งาน</span>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                              <v-flex xs2 sm2>
                                <v-icon>chat</v-icon>
                              </v-flex>
                              <v-flex>
                                <v-layout row wrap align-center>
                                  <span  style="cursor:pointer;" @click.stop="dialogus = !dialogus" class="footerlink">ส่งข้อความถึงเรา</span>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-title>
          </v-card>
        </v-footer>
      </div>
        <div class="problemIconMobile hidden-md-and-up">
          <v-tooltip left>
           <v-btn fab dark slot="activator" @click.stop="dialogProblem = !dialogProblem" style="background: #2662af;   height: 40px !important;width: 40px !important;">
             <v-icon style="font-size: 20px;">fas fa-bullhorn</v-icon>
           </v-btn>
            <span>พบเจอปัญหา</span>
          </v-tooltip>
        </div>
    </div>
    <v-layout row wrap v-else>
      <Login/>
    </v-layout>
</template>
<script>
import { Decode } from '@/services'
import messageusDialog from '@/components/chat/dialog/message/messageus'
import ProblemDialog from '@/components/homepage/ProblemDialog'
import Login from '@/components/homepage/login'
export default {
  data () {
    return {
      openedApp: false,
      snackbar: false,
      textsnackbar: 'ดาวน์โหลดแอปพลิเคชัน One Chat',
      deviceos: '',
      status_login: '',
      onechat:'One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้',
      // snackbar: true,
      deviceos: '',
      dialogProblem: false,
      dialogus: false,
      cardtext: [
        { text: 'ส่งข้อความ, ไฟล์, เสียง, รูปภาพ และยังมีฟังก์ชันอื่น ๆ' ,icon:'/static/img/homepage/icon/chat2x.png'},
        { text: 'บริการในตระกูล One Platform' ,icon:'/static/img/homepage/icon/one2x.png'},
        { text: 'เชื่อมต่อกับ One E-mail ที่ให้บริการฟรีอีเมล' ,icon:'/static/img/homepage/icon/mail2x.png'},
        { text: 'การใช้งาน Chat Bot' ,icon:'/static/img/homepage/icon/bot2x.png'},
        { text: 'มีบริการ One Box ที่ให้บริการฟรีพื้นที่จัดเก็บไฟล์ข้อมูล' ,icon:'/static/img/homepage/icon/box2x.png'},
        { text: 'ระบบความน่าเชื่อถือในตัวบุคคล' ,icon:'/static/img/homepage/icon/security2x.png'},
      ],
      onechatDev: process.env.ONECHATDEV + 'docs'
    }
  },
  components: {
    ProblemDialog,
    messageusDialog,
    Login
  },
  created () {
    // this.$router.push('/not_found')
      if (this.$route.params.type === 'friend' || this.$route.params.type === 'group') {
        // this.redirectto('onechat://com.oneplatform/qrcode/' + this.$route.params.type + '?id=' + this.$route.query.id)
      } else if (this.$route.params.type === 'market') {
        this.redirectto('onechat://com.oneplatform/market/')
      } else if (this.$route.params.type === 'market_link') {
        this.redirectto('onechat://com.oneplatform/market_link?link=' + this.$route.query.link)
      } else if (this.$route.params.type === 'link-to-bot-room') {
        this.redirectto('onechat://com.oneplatform/link-to-bot-room?bot_token=' + this.$route.query.bot_token)
      } else if (this.$route.params.type === 'qrcode-go-room') {
        try {
          this.redirectto('onechat://com.oneplatform/qrcode-go-room?bot_token=' + this.$route.query.bot_token + '&data=' + this.$route.query.data)
        } catch(error) {
          alert('jam ' + error)
        }
      } else if (this.$route.params.type === 'go-ekyc') {
        this.redirectto('onechat://com.oneplatform/go-ekyc?bot_token=' + this.$route.query.bot_token)
      } else {
        this.$router.push('/not_found')
      }

    // this.$cookie.set('status_login', 'T')
    // var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    // this.status_login = decoded['status_login']
    // if (this.status_login === 'T') {
    //   this.$cookie.set('path_type', this.$route.params.type)
    //   this.$cookie.set('path_id', this.$route.query.id)
    //   this.$router.push('/chat')
    // } else {
    //   // console.log(this.$cookie.get('status_login'))
    // }

    // console.log(Decode.decode(localStorage.getItem('Authenrization')))

    try {
      // console.log(Decode.decode(localStorage.getItem('Authenrization')))
      var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
      // console.log(decoded)
      this.status_login = decoded['status_login']
    } catch(er) {
      console.log(er)
    }
    // console.log(this.status_login)

    if (this.$route.params.type == 'friend' || this.$route.params.type === 'weburl-go-room') {
      if (this.status_login === 'T') {
        this.$cookie.set('path_type', this.$route.params.type)
        this.$cookie.set('path_id', this.$route.query.id)
        console.log(window.innerWidth)
        if (window.innerWidth <= 960) {
          this.$router.push('/mobile/homepage')
        } else {
          this.$router.push('/chat')
        }
      } else {
        console.log(`type: ${this.$route.params.type}`)
        console.log(`status login: ${this.status_login}`)
        this.$cookie.set('path_type', this.$route.params.type)
        this.$cookie.set('path_id', this.$route.query.id)
        // this.$router.push('/login')
      }
    }
  },
  methods: {
    openAppOrStore(url, store) {
      console.log(store)
      var me = this
      setTimeout(function () {
        if (!me.openedApp) {
          window.location = store;
        }
      }, 25);
      try {
          window.location = url;
          if (window.location.href.indexOf("onechat://") !== -1) {
              me.openedApp = true;
          }
      } catch (e) {
      }
    },
    redirectto (url) {
      var me = this
      var userAgent = navigator.userAgent || navigator.vendor || window.opera
      // console.log(userAgent)
      setTimeout(function () {
        if (/iPad|iPhone|iPod|Macintosh/.test(userAgent) && !window.MSStream) {
          // console.log(me.$route.query.service)
          // console.log(me.$route.params.type)
          // console.log(me.$route.name)
          // if(me.$route.params.type && me.$route.query.service) {
          //   if (me.$route.params.type !== 'friend' || me.$route.query.service !== 'onemeet') {
          //     me.openAppOrStore(url, 'https://apps.apple.com/th/app/onechat/id1394435274#?platform=iphone');
          //   }
          // } else
          if(me.$route.params.type) {
            me.openAppOrStore(url, 'https://apps.apple.com/th/app/onechat/id1394435274#?platform=iphone');
          }
        } else {
          me.openAppOrStore(url, 'https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat');
        }
      }, 25)
    },
    redirectto2 (url) {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // if (/android/i.test(userAgent)) {
      //   setTimeout(function () { window.location = "https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat"; }, 25);
      //   window.location = url;
      // }
      // if (/iPad|iPhone|iPod|Macintosh/.test(userAgent) && !window.MSStream) {
      //   setTimeout(function () { window.location = "https://itunes.apple.com/th/app/onechat/id1394435274?mt=8"; }, 25);
      //   window.location = url;
      // }
      // return "unknown";



       if (/iPad|iPhone|iPod|Macintosh/.test(userAgent) && !window.MSStream) {
        var now = new Date().valueOf();
        setTimeout(function () {
        if (new Date().valueOf() - now > 100) return;
          window.location = "https://apps.apple.com/th/app/onechat/id1394435274#?platform=iphone";
        }, 25);
        window.location = url;
      } else {
        var now = new Date().valueOf();
        setTimeout(function () {
          if (new Date().valueOf() - now > 100) return;
          window.location = "https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat";
        }, 25);
        window.location = url;
      }






    },
    toNewTab () {
      window.open(process.env.WEBchatdev, '_blank').focus()
    },
    toPage (page) {
      this.$router.push(page)
    },
    downloadios () {
      window.open('https://itunes.apple.com/th/app/onechat/id1394435274?mt=8').focus()
    },
    downloadandroid () {
      window.open('https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat').focus()
    },
    closedownload () {
      this.snackbar = false
    },
    loadepage () {
      window.open('http://onelink.to/hpyvpk', '_blank')
    },
    closeDialogProblem (value) {
      this.dialogProblem = value
    },
    closeDialogus (value) {
      this.dialogus = value
    }
  }
}
</script>
<style type="text/css" scoped>
.footer {
   position: relative;
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: #00000000 !important;
   color: white;
   text-align: center;
   margin-top: 10em;
}
>>> div.typed-element {
  display: flex;
  align-items: center;
  justify-content: center;
}

#particles-js {
  color: #fff;
  width: 100%;
  height: 100%;
  background-color: #000;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
}

$text: #fff;
$link: #e34234;
$link-hover: #ba160c;
$background: #00356B;


#particles-js {
  position: absolute;
  width: 100%;
  height: 100%;
  background: $background
}

.text {
  /* position: absolute; */
  position: relative;
  top: 10%;
  /* top: 45%;
  right: 50%; */
  /* transform: translate(50%,-50%); */
  top: 15%;
  color: $text;
  width: 100%;
  padding: 2em 3em;
  font-family: 'CS ChatThaiUI' !important;
  /* height: 70vh; */
  /* overflow-y:auto; */
}
/*.textmo {
  position: absolute;
  top: 45%;
  right: 50%;
  transform: translate(50%,-50%);
  color: $text;
  width: 100%;
  padding: 2em 3em;
  font-family: 'CS ChatThaiUI' !important;
}*/
h1 {
  font-size: 2.25em;
  font-weight: 700;
  letter-spacing: -1px;
}
a,
a:visited {
  color: $link;
  transition: 0.25s;
}
a:hover,
a:focus {
  color: $link-hover;
}
.problemIcon {
  border-radius: 10px;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  padding: 0px;
  border: 0px;
  background: transparent;
  position: fixed;
  z-index: 16000002;
  width: 130px;
  height: 80px;
  right: 10px;
  bottom: 15px;
}

/* .textFooter {
  text-align: right; padding-right: 5px;
  color: black;
}
.textFooterCompany {
  padding-left: 20px;
  padding-right: 20px;
  color: black !important;
} */
.iconDownload {
  margin-top: 0vw;
  width: 60px;
  height: 36px;
}
.Background{
  background-image: url('/static/img/homepage/wallpaper-website.png');
  object-fit: contain;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.BackgroundMobile{
  background-image: url('/static/img/homepage/wallpaper-mobile.png');
  object-fit: contain;
  background-size: 100% 100%;
}
.cardstyle{
  margin-top:10px;
  border-radius: 10px;
  margin-left:40px;
  margin-right:40px;
}
.cardstyleMobile{
  border-radius: 10px;
  margin-bottom: 55px;
  margin-left:20px;
  margin-right:20px;
}
.item {
  min-height: 50px;
  min-width: 80px;
   margin: 10px;
}
.textincard {
  font-size: 20px;
  /* font-weight:bold; */
  padding-left:2em;
  padding-right: 2em;
  text-align: center;
}
.textincardMobile {
  font-size: 16px;
  padding-left:1em;
  padding-right: 1em;
  text-align: center;
}
.iconcard{
  position: absolute;
  z-index: 1;
  top: -30px;
}
.problemIconMobile{
  border-radius: 10px;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  padding: 0px;
  border: 0px;
  background: transparent;
  position: absolute;
  z-index: 16000002;
  /* width: 100px; */
  height: 80px;
  right: 10px;
  bottom: 15px;
}

/*  */
.centered {
  display: flex;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
}
.download {
  cursor: pointer;
}
.footertitle{
  padding-top: 50px;
  padding-bottom: 10px;
}
.footermobiletext{
  padding-top: 50px;
  padding-bottom: 10px;
}
.footerMobile{
  padding-top: 50px;
  /* padding-bottom: 10px; */
}
.btnhover:hover{
  color: white;
}
.footerlink{
  color:black;
  text-decoration: none;
}
.footerlink:hover{
  color:#1976d2;
}
</style>



// WEBPACK FOOTER //
// src/components/qrcodeRedirect.vue